module.exports = __webpack_public_path__ + "static/img/3917_jdbbkb3z.795db88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3917_jdbbkb3z.png
// module id = +B9/
// module chunks = 0